import * as ActionConfigurationManager from './config.actions'

export const cartTaxTokenRefresh = ActionConfigurationManager.REFRESH_TOKEN_CART_TAX
export const cartTaxTokenRefreshSuccess = ActionConfigurationManager.REFRESH_TOKEN_CART_TAX_SUCCESS
export const checkoutAVSTokenRefresh = ActionConfigurationManager.REFRESH_TOKEN_AVS_TAX
export const checkoutAVSTokenRefreshSuccess = ActionConfigurationManager.REFRESH_TOKEN_AVS_TAX_SUCCESS
export const purchaseContractTokenRefresh = ActionConfigurationManager.REFRESH_TOKEN_PURCHASE_CONTRACT
export const purchaseContractTokenRefreshSuccess = ActionConfigurationManager.REFRESH_TOKEN_PURCHASE_CONTRACT_SUCCESS
